<template>
  <v-row
    align="stretch"
    justify="start"
  >
    <v-col
      cols="12"
    >
      <base-material-card
        color="coolrunner"
        icon="mdi-account"
        inline
        class="px-5 py-3"
        lg="4"
      >
        <template v-slot:after-heading>
          <v-col>
            <div class="text-h2 font-weight-light">
              {{ $t('invoices') }}
            </div>
          </v-col>
        </template>
        <v-row>
          <v-col cols="12">
            <v-select
              :loading="loadingDebtors"
              :value="debtor"
              :label="$t('debtor')"
              dense
              :items="debtors"
              return-object
              :item-text="item => `${item.invoice_company_name} (${item.invoice_debtor_number}) (${item.currency_code})`"
              @change="onDebtorChange"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-card
              class="pa-2 mt-0"
              :loading="loadingInvoices"
            >
              <div
                v-if="debtor"
                class="text-h2 text-center"
              >
                {{ `${debtor.invoice_company_name} (${debtor.invoice_debtor_number}) (${debtor.currency_code})` }}
              </div>
              <table style="width: 100%;">
                <thead>
                  <th
                    v-for="header in headers"
                    :key="header"
                    :width="`${100/headers.length}%`"
                    style="text-align:left; border-collapse: collapse;"
                  >
                    {{ header }}
                  </th>
                </thead>
                <tbody>
                  <tr
                    v-for="line in invoices"
                    class="invoice-line"
                  >
                    <td style="border-bottom: 1px dashed black;">
                      {{ line.description }}
                    </td>
                    <td style="border-bottom: 1px dashed black;">
                      {{ line.unitPrice }}
                    </td>
                    <td style="border-bottom: 1px dashed black;">
                      {{ line.quantity }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-card>
          </v-col>
        </v-row>
      </base-material-card>
    </v-col>
  </v-row>
</template>
<script>
  import localStorage from '../../../../plugins/localstorage'
  import Auth from '../../../../mixins/Auth'
  import _ from 'lodash'
  export default {

    mixins: [Auth],
    props: {
      loading: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {
        name: 'invoices',
        headers: [
          'Description',
          'Unit price',
          'Quantity',
        ],
        debtors: [],
        loadingDebtors: true,
        loadingInvoices: false,
        debtor: null,
        invoices: [],
      }
    },
    mounted: function () {
      this.getDebtors()
    },
    methods: {
      getDebtors: function () {
        this.loadingDebtors = true
        this.$get(`invoices/debtor/${this.$route.params.id}`)
          .then(res => {
            this.debtors = res.data
          })
          .finally(() => {
            this.loadingDebtors = false
          })
      },
      onDebtorChange: function (debtor) {
        this.debtor = debtor
        this.loadingInvoices = true
        this.$get(`invoices/invoice/${this.$route.params.id}`, {
          ...debtor,

        })
          .then(res => {
            this.invoices = res.data?.lines
          })
          .finally(() => {
            this.loadingInvoices = false
          })
      },
    },
  }
</script>

<style scoped>
  .invoice-line:hover {
    background: lightgray;
  }
</style>
